import React, { useState } from "react";
import { Input, InputProps } from "./Input";
import { PolyIconButton } from "../../elements";

export const PasswordInput: React.FC<InputProps> = ({ name, label }) => {
  const [isPasswordHidden, setPasswordHidden] = useState(true);

  return (
    <div className="form-group">
      <label className="col-4 text-right" htmlFor={name + "-input"}>
        {label}:
      </label>
      <div className="col-4">
        <Input
          name={name}
          data-testid={name}
          type={!isPasswordHidden ? "text" : "password"}
        />
      </div>
      <div className="col-1">
        <PolyIconButton
          className="clickable"
          data-testid="show-password"
          type="button"
          icon={isPasswordHidden ? "eye" : "eye_slash"}
          onClick={() => setPasswordHidden(!isPasswordHidden)}
        />
      </div>
    </div>
  );
};
